import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
export const ApeLogo = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="m4.933 3.96 1.935 16.083H4.325l-.283-3.5H2.695l-.283 3.5H0L1.934 3.96h3ZM3.39 8.328h-.065L3.13 11.11l-.261 3.304h1l-.283-3.304-.196-2.782Zm9.611-4.368c1.848 0 2.978 1.087 2.978 3.043v3.955c0 1.934-1.13 3.021-2.978 3.021h-.804v6.064H9.611V3.96Zm-.217 1.934h-.565v6.15h.565c.435 0 .608-.39.608-1.086V7.003c0-.718-.173-1.109-.608-1.109Zm6.174-1.934v16.083H24v-2.13h-2.456v-4.934h2.195v-2.13h-2.195V6.09H24V3.96h-5.042Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};